import React from 'react';
import { Box } from '@apia/theme';
import {
  TAccordionCellRenderer,
  TAccordionCellRendererProps,
} from './AccordionCell';
import { getStatusRendererClassName } from './StatusRenderer';

const NoMemoStatusAccordionRenderer: TAccordionCellRenderer = React.forwardRef<
  HTMLTableCellElement,
  TAccordionCellRendererProps
>(({ cell, column }, currentRef) => {
  const taskStatusClassName = getStatusRendererClassName(
    cell.children as string,
    column.name,
  );

  return (
    <Box ref={currentRef}>
      <Box as="strong">{column.label ?? column.name}: </Box>
      <Box as="span" className={taskStatusClassName}>
        {cell.children}
      </Box>
    </Box>
  );
});

NoMemoStatusAccordionRenderer.displayName = 'StatusAccordionRenderer';

export const StatusAccordionRenderer = NoMemoStatusAccordionRenderer;
